










































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import {
  JobDetail,
  Image,
  Company,
  Worker,
  Conversation
} from '@/@types/LibraryComponent';

@Component
export default class Condition extends Vue {
  @Prop()
  private job!: JobDetail;

  private get price(): string {
    return (this.job.price * 10000).toLocaleString();
  }
}
